import { useTranslation } from 'react-i18next';
import { SpaClosingTemplate } from './SpaClosingTemplate';

export const SpaIsClosed = () => {
  const { t } = useTranslation();

  return (
    <SpaClosingTemplate
      title={t('SpaClosingProcedure.Closed.Title')}
      description={<p>{t('SpaClosingProcedure.Closed.Description')}</p>}
    />
  );
};
